import type { Locale } from '$lib/i18n/types';
import { page } from '$app/stores';
import { get } from 'svelte/store';

export const magazineUrlByLocale: Record<Locale, string> = {
	'fr-FR': 'https://www.viamichelin.fr/magazine/',
	'fr-BE': 'https://www.viamichelin.fr/magazine/',
	'fr-CH': 'https://www.viamichelin.fr/magazine/',
	'en-GB': 'https://www.viamichelin.com/magazine/',
	'en-IE': 'https://www.viamichelin.com/magazine/',
	'en-US': 'https://www.viamichelin.com/magazine/',
	'de-AT': 'https://www.viamichelin.de/magazine/',
	'de-CH': 'https://www.viamichelin.de/magazine/',
	'de-DE': 'https://www.viamichelin.de/magazine/',
	'it-CH': 'https://www.viamichelin.it/magazine/',
	'it-IT': 'https://www.viamichelin.it/magazine/',
	'es-ES': 'https://www.viamichelin.es/magazine/',
	'nl-BE': 'https://www.viamichelin.com/magazine/',
	'nl-NL': 'https://www.viamichelin.com/magazine/',
	'pt-PT': 'https://www.viamichelin.com/magazine/',
};

export function getMagazineUrl() {
	return magazineUrlByLocale[get(page).data?.locale ?? 'en-US'];
}

export function getMagazineUrlWithTracking(utmMedium: string) {
	const magUrlByDefinedLocale = new URL(magazineUrlByLocale[get(page).data?.locale ?? 'en-US']);
	magUrlByDefinedLocale.searchParams.set('utm_source', 'viamichelin_web');
	magUrlByDefinedLocale.searchParams.set('utm_medium', utmMedium);

	return magUrlByDefinedLocale.toString();
}
